var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15173",
    "data-name": "Group 15173",
    transform: "translate(-1622 -99)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1997",
    "data-name": "Rectangle 1997",
    width: 45,
    height: 45,
    transform: "translate(1622 99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15171",
    "data-name": "Group 15171",
    transform: "translate(1626 105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15170",
    "data-name": "Group 15170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "user-list",
    d: "M37.223,21.991a1.9,1.9,0,0,0-1.407-.622H1.9a1.9,1.9,0,0,0-1.9,2.08L1.817,42.886a1.9,1.9,0,0,0,1.9,1.727H34.006a1.9,1.9,0,0,0,1.9-1.727L37.711,23.45A1.9,1.9,0,0,0,37.223,21.991ZM25.209,40.627H12.514a1.9,1.9,0,0,1-1.9-1.9A4.694,4.694,0,0,1,15.3,34.035h1.366a4.554,4.554,0,1,1,4.389,0h1.366a4.694,4.694,0,0,1,4.686,4.531c0,.052.006.1.006.157A1.9,1.9,0,0,1,25.209,40.627Zm8.848-22.8a1.428,1.428,0,0,1-1.428,1.428H5.09a1.428,1.428,0,1,1,0-2.855H32.63A1.428,1.428,0,0,1,34.057,17.826Zm-3.769-5.267a1.428,1.428,0,0,1-1.428,1.428h-20a1.428,1.428,0,1,1,0-2.855h20A1.428,1.428,0,0,1,30.288,12.559Z",
    transform: "translate(0 -11.131)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1993",
    "data-name": "Rectangle 1993",
    width: 20.038,
    height: 17.533,
    transform: "translate(8.331 13.358)",
    fill: "#3f2566"
  })), /*#__PURE__*/React.createElement("g", {
    id: "university",
    transform: "translate(10.315 14.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15169",
    "data-name": "Group 15169",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7935",
    "data-name": "Path 7935",
    d: "M16.357,28.842V27.4L8.178,22.588,0,27.4v1.443H1.443v7.216H.481V37.5H15.875V36.058h-.962V28.842ZM5.292,34.615H3.368V28.842H5.292Zm3.849,0H7.216V28.842H9.14ZM8.178,27.4a1.443,1.443,0,1,1,1.443-1.443A1.443,1.443,0,0,1,8.178,27.4Zm4.811,7.216H11.065V28.842h1.924Z",
    transform: "translate(0 -22.588)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadIcon3);
export default __webpack_public_path__ + "static/media/head-icon3.0da882b183d6970d133616d3e7ad0ee5.svg";
export { ForwardRef as ReactComponent };